
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class HyperlinkFieldView extends Vue {
  @Prop({ type: String, default: '' }) value!: string
}
